// Normalizes a listing's `images` array. Some imported products stored an
// entry that is itself a JSON-encoded array of URLs (e.g. '["u1","u2",...]')
// instead of separate strings — this flattens those into individual URLs,
// drops blanks, and de-dupes while preserving order.
export function normalizeImages(images) {
  if (!Array.isArray(images)) return [];
  const out = [];
  for (const x of images) {
    if (typeof x !== "string") continue;
    const s = x.trim();
    if (s.startsWith("[")) {
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr)) {
          arr.forEach((u) => {
            if (u && typeof u === "string") out.push(u.trim());
          });
          continue;
        }
      } catch (e) {
        /* not valid JSON — fall through and treat as a normal URL */
      }
    }
    if (s) out.push(s);
  }
  return Array.from(new Set(out));
}
